var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPhone = function SvgIcPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41239 7.22502C9.14364 7.01877 8.77489 7.01877 8.52489 7.23127L7.64989 7.99377C7.37489 8.22502 7.00614 8.27502 6.64364 7.98752C6.10614 7.55627 4.49364 5.90627 4.01864 5.36252C3.66864 4.96252 3.77489 4.62502 4.00614 4.35002L4.76864 3.47502C4.98114 3.22502 4.97489 2.86252 4.77489 2.58752C4.34989 2.03752 4.04989 1.62502 3.66239 1.06877C3.14364 0.325023 2.56239 0.043773 1.69989 0.906273C1.48739 1.11877 1.29989 1.35002 1.11864 1.58752C0.199892 2.80002 0.124891 4.20002 0.937391 5.61252C1.75614 7.03752 4.88114 10.1625 6.38739 11.0625C7.78739 11.8938 9.19989 11.8 10.4124 10.8813C10.6499 10.7 10.8811 10.5063 11.0936 10.2938C11.9561 9.43752 11.6749 8.85627 10.9311 8.33752C10.3749 7.95002 9.96239 7.65002 9.41239 7.22502Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_phone.00e10a6e.svg";
export { ForwardRef as ReactComponent };